/**
 * Object types that can be linked to cases.
 * This is a subset of NativeObjectType excluding 'case' which is not supported.
 */
export enum CaseObjectLinkType {
  Rider = 'rider',
  Driver = 'driver',
  Duty = 'duty',
  Service = 'service',
  Request = 'request',
  Fleet = 'fleet',
  Membership = 'groupMembership',
  Vehicle = 'vehicle',
}
